import React from 'react';
import { Switch, Route } from 'react-router';

import TabTeam from './TabTeam';

const Team = () => (
  <Switch>
    <Route path={[
      '/dashboard/user/organizations/:id/team',
      '/dashboard/admin/organizations/:id/team',
      '/dashboard/user/organizations/:id/team/new',
      '/dashboard/admin/organizations/:id/team/new',
      '/dashboard/user/organizations/:id/team/:teamId',
      '/dashboard/admin/organizations/:id/team/:teamId',
    ]}
    exact
    >
      <TabTeam />
    </Route>
  </Switch>
);

export default Team;
